import React, { Component } from 'react';
import axios from 'axios';
import { Form, Button, Modal } from 'react-bootstrap';
import StartEndDate from '../components/startEndDate/StartEndDate';
import BusinessType from '../components/businessType/BusinessType';
import DisplayType from '../components/displayType/DisplayType';
import AgentCodeName from '../components/agentCodeName/AgentCodeName';
import CoverNoteStatus from '../components/coverNoteStatus/CoverNoteStatus';
import TransactionType from '../components/transactionType/TransactionType';
import PolicyEndorsementIssued from '../components/policyEndorsementIssued/PolicyEndorsementIssued';
import config from '../../config/config';
import { momentToISOString } from '../../utils/dateUtils'
import ProgressBar from '../components/progressBar/ProgressBar';

const appUrlPath = `/${config.appUrlPath}`;
const FileDownload = require('react-file-download');

export class CoverNoteReport extends Component {
  constructor(props) {
    super(props);
    const role = localStorage.getItem('role');
    const agentCode = role === 'agent' ? localStorage.getItem('agentCode') : '';
    const agentName = role === 'agent' ? localStorage.getItem('displayName') : '';
    this.state = {
      redirect: false,
      isLoading: false,
      startDate: null,
      endDate: null,
      previousFrom: null,
      previousTo: null,
      agentCode,
      agentName,
      role,
      transactionType: '',
      businessType: '',
      coverNoteStatus: '',
      displayType: 'html',
      policyEndorsementIssued: '',
      showModal: false,
      message: ''
    }
    this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
    this.handleChangeEndDate = this.handleChangeEndDate.bind(this);
    this.handleChangePreviousFrom = this.handleChangePreviousFrom.bind(this);
    this.handleChangePreviousTo = this.handleChangePreviousTo.bind(this);
    this.handleChangeTransactionType = this.handleChangeTransactionType.bind(this);
    this.handleChangeBusinessType = this.handleChangeBusinessType.bind(this);
    this.handleChangeDisplayType = this.handleChangeDisplayType.bind(this);
    this.handleChangeCoverNoteStatus = this.handleChangeCoverNoteStatus.bind(this);
    this.handleChangePolicyEndorsementIssued = this.handleChangePolicyEndorsementIssued.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleGetAgentName = this.handleGetAgentName.bind(this);
    this.handleChangeAgentCode = this.handleChangeAgentCode.bind(this);
    this.close = this.close.bind(this);

    axios.get(`${appUrlPath}/getCsrfToken`, {
      params: {},
      headers: { 'ACTION-LOG': 'Access Cover Note Report Page' }
    })
    .then((res) => {
      axios.defaults.headers.common = {
        'CSRF-TOKEN': res.data.csrfToken
      };
    })
    .catch(() => {
    });
  }

  handleChangeStartDate(date) {
    if (date != null) {
      this.setState({
        startDate: momentToISOString(date)
      });
    }
  }

  handleChangeEndDate(date) {
    if (date != null) {
      this.setState({
        endDate: momentToISOString(date)
      });
    }
  }

  handleChangePreviousFrom(date) {
    if (date != null) {
      this.setState({
        previousFrom: momentToISOString(date)
      });
    }
  }

  handleChangePreviousTo(date) {
    if (date != null) {
      this.setState({
        previousTo: momentToISOString(date)
      });
    }
  }

  handleChangeTransactionType(e) {
    this.setState({
      transactionType: e.target.value
    });
  }

  handleChangeBusinessType(e) {
    this.setState({
      businessType: e.target.value
    });
  }

  handleChangeDisplayType(e) {
    this.setState({
      displayType: e.target.value
    });
  }

  handleChangeCoverNoteStatus(e) {
    this.setState({
      coverNoteStatus: e.target.value
    });
  }

  handleChangePolicyEndorsementIssued(e) {
    this.setState({
      policyEndorsementIssued: e.target.value
    });
  }

  handleClick() {
    window.location.assign('/en/motorb2b/home');
  }

  handleChangeAgentCode(e) {
    const agentCode = e.target.value;
    this.setState({
      agentCode
    });
  }

  handleGetAgentName(e) {
    const agentCode = e.target.value;
    axios.post(`${appUrlPath}/getAgentName`, {
      agentCode
    })
    .then((res) => {
      this.setState({
        agentName: res.data.agentName
      })
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    // validation
    const startDate = this.state.startDate;
    const endDate = this.state.endDate;
    const displayType = this.state.displayType;
    const responseType = displayType === 'excel' ? 'arraybuffer' : '';
    if (!startDate || !endDate) {
      this.setState({
        message: 'The start date or end date cannot be null.',
        showModal: true
      });
      return;
    }
    this.setState({ isLoading: true })
    let myWindow = null;
    if (displayType != 'excel') {
      myWindow = window.open('', '_blank', '');
    }
    axios.post(`${appUrlPath}/generateAgentCoverNoteReport`, {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      agentCode: this.state.agentCode,
      agentName: this.state.agentName,
      transactionType: this.state.transactionType,
      businessType: this.state.businessType,
      coverNoteStatus: this.state.coverNoteStatus,
      displayType: this.state.displayType,
      policyEndorsementIssued: this.state.policyEndorsementIssued
    }, { responseType })
    .then((response) => {
      this.setState({ isLoading: false })
      if (displayType === 'excel') {
        FileDownload(response.data, 'report.xlsx');
      } else {
        // const myWindow = window.open('', '_blank', '');
        myWindow.document.write(response.data);
      }
    })
    .catch((error) => {
      let errorMsg = '';
      if (error.response) {
        errorMsg = error.response.data; 
      }
      if (myWindow) {
        myWindow.close();
      }
      this.setState({
        message: errorMsg || 'Generate Fail.',
        showModal: true,
        isLoading: false
      });
    });
  }

  close() {
    this.setState({ showModal: false });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <ProgressBar />
      )
    }

    return (
      <div>
        {this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.message}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}
        <h2 className="ebaoUtil__HeaderTwo">Cover Note Report Listing</h2>
        <h3 className="ebaoUtil__HeaderThree">Reporting Condition</h3>
        <Form onSubmit={this.handleSubmit}>
          <div className="ebaoUtil__Form-80">
            <StartEndDate
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            startDateLabel="Start Date*"
            endDateLabel="End Date*"
            handleChangeStartDate={this.handleChangeStartDate}
            handleChangeEndDate={this.handleChangeEndDate}
            />
            <AgentCodeName
            agentCode={this.state.agentCode}
            agentName={this.state.agentName}
            handleGetAgentName={this.handleGetAgentName}
            handleChangeAgentCode={this.handleChangeAgentCode}
            systemRole={this.state.role}
            required={false}
            />
            <TransactionType handleChangeTransactionType={this.handleChangeTransactionType} transTypeValue={this.state.transactionType} />
            <BusinessType handleChangeBusinessType={this.handleChangeBusinessType} businessTypeValue={this.state.businessType} />
            <CoverNoteStatus handleChangeCoverNoteStatus={this.handleChangeCoverNoteStatus} coverNoteStatusValue={this.state.coverNoteStatus} />
            <DisplayType handleChangeDisplayType={this.handleChangeDisplayType} defaultDisplayType={this.state.displayType} />
            <PolicyEndorsementIssued handleChangePolicyEndorsementIssued={this.handleChangePolicyEndorsementIssued} policyEndorsementIssued={this.state.policyEndorsementIssued} />
            <div className="ebaoUtil__Row">
              <div className="ebaoUtil__ButtonGroup">
                <button type="submit" className="btn btn-axa">Generate Report</button>{' '}
                <button type="button" className="btn btn-axa" onClick={this.handleClick}>Exit</button>
              </div>
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

export default CoverNoteReport;



// WEBPACK FOOTER //
// ./src/app/pages/CoverNoteReport.js